module.exports = __webpack_public_path__ + "media/img/corporate/targeted_email-70f2003557e5329e0df9917323dcd3ff.png";